<template>
  <div class="pc-page-settings__header">
    设置
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

.pc-page-settings__header {
  font-size: 2rem;
  margin-bottom: 3rem;
  font-weight: bold;
}
</style>
